import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const ServiceAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default ServiceAddButton;